import api from "./api";

export const getAllHostAvailabilities = async (schemaName = null) => {
  try {
    const response = await api.get("/host-availability/", {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching host availabilities:", error);
    throw error;
  }
};

export const getHostAvailabilityById = async (id, schemaName = null) => {
  try {
    const response = await api.get(`/host-availability/${id}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching host availability:", error);
    throw error;
  }
};

export const createHostAvailability = async (data, schemaName = null) => {
  try {
    const response = await api.post("/host-availability/", data, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error creating host availability:", error);
    throw error;
  }
};

export const updateHostAvailability = async (id, data, schemaName = null) => {
  try {
    const response = await api.patch(`/host-availability/${id}/`, data, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error updating host availability:", error);
    throw error;
  }
};

export const deleteHostAvailability = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/host-availability/${id}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting host availability:", error);
    throw error;
  }
};
